module.exports = __webpack_public_path__ + "static/media/Trainicon01.28679c68.png";